import { all, takeEvery, put } from 'redux-saga/effects';
import siteConfig from '@iso/config/site.config';
import actions from './actions';
import { notification } from '@iso/components';
const gaxios = require('gaxios');
gaxios.instance.defaults = {
    baseURL: siteConfig.siteUrl.API_URL
}

export function* getCompras(action) {
    const query = action.query ? `?${action.query}` : '';
    const res = yield gaxios.request({
        url: 'api/compras' + query,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        yield put({
            type: actions.GET_COMPRAS_SUCCESS,
            payload: res.data.compras,
        });
    }
}
export function* createCompra(action) {
    const res = yield gaxios.request({
        url: 'api/compras',
        method: 'POST',
        data: action.data,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield action.history.push('/dashboard/lista-compras');  //TODO: La linea comentada de error cuando se llama desde registrar compra
        yield put({ type: actions.GET_COMPRAS_REQUEST });
    }
}
export function* editCompra({ payload }) {
    const res = yield gaxios.request({
        url: 'api/compras/' + payload._id,
        method: 'PUT',
        data: payload,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        if (payload.pago) {
            yield put({ type: actions.GET_COMPRAS_REQUEST, query: 'pago=false' });
        } else {
            yield put({ type: actions.GET_COMPRAS_REQUEST });
        }
    }
}

export function* impCompra(payload) {
    const res = yield gaxios.request({
        url: 'api/compras/importar',
        method: 'POST',
        data: payload.data,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
    }
}

export default function* rootSaga() {
    yield all([
        yield takeEvery(actions.GET_COMPRAS_REQUEST, getCompras),
        yield takeEvery(actions.CREATE_COMPRA_REQUEST, createCompra),
        yield takeEvery(actions.EDIT_COMPRA_REQUEST, editCompra),
        yield takeEvery(actions.IMPORTAR_COMPRAS, impCompra),
    ]);
}
